import { Route, Routes } from "react-router-dom";
import Complete from "./pages/complete";
import Main from "./pages/main";
import AdminRecovery from "./pages/admin-recovery";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Main />}></Route>
        <Route path="/complete" element={<Complete />}></Route>
        <Route path="/admin-recovery" element={<AdminRecovery />}></Route>
      </Routes>
    </>
  );
}

export default App;
